<div class="searchbar__search-bar">
  <mat-icon class="searchbar__search-icon">search</mat-icon>

  <input class="searchbar__search-input" type="text" label="Searchbar" placeholder="Search by Mgmt ID or Mgmt Name..." [(ngModel)]="searchTerm"
    (input)="applySearch()" id="mgmtSearchBar" />

  <button *ngIf="searchTerm" mat-icon-button class="searchbar__search-clear" (click)="clearSearch()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="recentprojects-table-container">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom inco-master-table">
    <ng-container matColumnDef="mgmtId">
      <th mat-header-cell *matHeaderCellDef class="text-left">Mgmt ID</th>
      <td mat-cell *matCellDef="let row" class="text-left">{{ row.mgmtId }}</td>
    </ng-container>

    <ng-container matColumnDef="mgmtName">
      <th mat-header-cell *matHeaderCellDef class="text-left">Mgmt Name</th>
      <td mat-cell *matCellDef="let row" class="text-left">{{ row.mgmtName }}</td>
    </ng-container>

    <ng-container matColumnDef="projectId">
      <th mat-header-cell *matHeaderCellDef class="text-left">Project ID</th>
      <td mat-cell *matCellDef="let row" class="text-left">{{ row.id }}</td>
    </ng-container>

    <ng-container matColumnDef="projectTitle">
      <th mat-header-cell *matHeaderCellDef class="text-left">Title</th>
      <td mat-cell *matCellDef="let row" class="text-left">{{ row.projectTitle }}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created Date</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAtUtc | date:'yyyy-MM-dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="multiproject">
      <th mat-header-cell *matHeaderCellDef>Multiproject</th>
      <td mat-cell *matCellDef="let row">{{ row.multiprojectName }}</td>
    </ng-container>

    <ng-container matColumnDef="investmentType">
      <th mat-header-cell *matHeaderCellDef>Investment</th>
      <td mat-cell *matCellDef="let row">{{ row.investmentTypeName }}</td>
    </ng-container>

    <ng-container matColumnDef="informationTechnology">
      <th mat-header-cell *matHeaderCellDef>IT</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.informationTechnology) }}</td>
    </ng-container>

    <ng-container matColumnDef="manufacturing">
      <th mat-header-cell *matHeaderCellDef>MFG</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.manufacturing) }}</td>
    </ng-container>

    <ng-container matColumnDef="fieldOperations">
      <th mat-header-cell *matHeaderCellDef>FLD</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.fieldOperations) }}</td>
    </ng-container>

    <ng-container matColumnDef="researchDevelopment">
      <th mat-header-cell *matHeaderCellDef>Local R&D</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.researchDevelopment) }}</td>
    </ng-container>

    <ng-container matColumnDef="bigR">
      <th mat-header-cell *matHeaderCellDef>Big R</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.bigR) }}</td>
    </ng-container>

    <ng-container matColumnDef="maintenance">
      <th mat-header-cell *matHeaderCellDef>Maintenance</th>
      <td mat-cell *matCellDef="let row">{{ row.maintenance }}</td>
    </ng-container>

    <ng-container matColumnDef="expansion">
      <th mat-header-cell *matHeaderCellDef>Expansion</th>
      <td mat-cell *matCellDef="let row">{{ row.expansion }}</td>
    </ng-container>

    <ng-container matColumnDef="focus">
      <th mat-header-cell *matHeaderCellDef>Focus</th>
      <td mat-cell *matCellDef="let row">{{ getBooleanDisplay(row.focus) }}</td>
    </ng-container>

    <ng-container matColumnDef="phase">
      <th mat-header-cell *matHeaderCellDef>Phase</th>
      <td mat-cell *matCellDef="let row">{{ row.phaseName }}</td>
    </ng-container>

    <ng-container matColumnDef="changeLog">
      <th mat-header-cell *matHeaderCellDef>History</th>
      <td mat-cell *matCellDef="let project">
        <button mat-icon-button class="branch-excellence-changelog-button" matTooltip="Change Log" style="width:100%"
          (click)="viewprojectHistory(project)">
          <mat-icon>history</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row class="tableheader" *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
  </table>
</div>